import { put, takeEvery } from 'redux-saga/effects';
import { logout } from 'src/actions';
import { State, Type } from 'src/actions/utils';
import { isUnauthorizedResponseError } from 'src/utils';

function* handleUnauthorizedResponseError(action: any) {
  const { error } = action.payload;

  if (isUnauthorizedResponseError(error)) {
    yield put(logout());
  }
}

export function* registerCommonSagas() {
  // List of action types to watch for
  const actionTypesToWatch = [
    // Account actions
    State.actionFailed(Type.CREATE_ACCOUNT_HOLDER_PHYSICAL_ADDRESS),
    State.actionFailed(Type.PATCH_ACCOUNT_HOLDER_PHYSICAL_ADDRESS),
    State.actionFailed(Type.CREATE_ACCOUNT_HOLDER_MAILING_ADDRESS),
    State.actionFailed(Type.PATCH_ACCOUNT_HOLDER_MAILING_ADDRESS),
    State.actionFailed(Type.CREATE_ACCOUNT_HOLDER_TRUSTED_CONTACT),
    State.actionFailed(Type.PATCH_ACCOUNT_HOLDER_TRUSTED_CONTACT),
    State.actionFailed(Type.DELETE_ACCOUNT_HOLDER_TRUSTED_CONTACT),
    State.actionFailed(Type.UPDATE_ACCOUNT_SUITABILITY_INFORMATION),
    State.actionFailed(Type.UPDATE_ACCOUNT_FINANCIAL_ASSETS),
    State.actionFailed(Type.CREATE_ACCOUNT_HOLDER_FINANCIAL_INFORMATION_EMPLOYMENT),
    State.actionFailed(Type.PATCH_ACCOUNT_HOLDER_FINANCIAL_INFORMATION_EMPLOYMENT),
    State.actionFailed(Type.SUBMIT_ACCOUNT),

    // Account application actions
    State.actionFailed(Type.GET_ACCOUNT_APPLICATION),
    State.actionFailed(Type.DELETE_ACCOUNT_APPLICATION_DOCUMENT),
    State.actionFailed(Type.CANCEL_ACCOUNT_APPLICATION_DOCUMENT),
    State.actionFailed(Type.REFRESH_ACCOUNT_APPLICATION),

    // Transfer actions
    State.actionFailed(Type.CASHIERING_CANCEL_DEPOSIT),
    State.actionFailed(Type.CASHIERING_CANCEL_WITHDRAW),

    // Offer order actions
    State.actionFailed(Type.CANCEL_OFFER_ORDER),

    // Order actions
    State.actionFailed(Type.GET_CUMULATIVE_ORDER_LIST),
    State.actionFailed(Type.GET_ORDERS_ID),
    State.actionFailed(Type.CREATE_ORDER),
    State.actionFailed(Type.CANCEL_ORDER),

    // Quote actions
    State.actionFailed(Type.GET_QUOTE_LIST),
    State.actionFailed(Type.GET_QUOTE),
    State.actionFailed(Type.GET_QUOTE_CHART),
  ];

  yield takeEvery(actionTypesToWatch, handleUnauthorizedResponseError);
}
